import { render } from "./NavDesktopDropdown.vue?vue&type=template&id=16c485a0"
import script from "./NavDesktopDropdown.vue?vue&type=script&lang=js"
export * from "./NavDesktopDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/builds/etos-b2b/b2b-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__